import { render, staticRenderFns } from "./ForgotPasswordModal.vue?vue&type=template&id=fe2f5186&scoped=true&"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ForgotPasswordModal.vue?vue&type=style&index=1&id=fe2f5186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2f5186",
  null
  
)

export default component.exports